import React from "react";
import NnNote from "./NnNote";
import "./NnSongAnimations.scss";

class NnSong extends React.Component {

  constructor(props) {
    super(props);
    this.displayRef = React.createRef();
  }
  render() {
    const padding = 10; // padding and margin of each song element
    let position = this.props.position;
    let offset = (this.props.notes.slice(0, position).reduce((sum,note)=>(sum + (note.actualWidth+padding + 2 || 44)), 0) 
                 / [document.documentElement.clientWidth] * 100) - 25;
    let style = { left: -offset + 'vw' };
    let notes = this.props.notes;

    return (
      <ul className="song-display" style={style}>
        {notes.map((n, i) => (
          <NnNote note={n} key={i} index={i}
            active={i === position}
            displayLetters={this.props.displayLetters}
            displayTiming={this.props.displayTiming}
          />
        ))}
      </ul>
    );
  }
}
export default NnSong;
